import script from "./EmotionImagesField.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmotionImagesField.vue?vue&type=script&setup=true&lang=ts"

import "./EmotionImagesField.vue?vue&type=style&index=0&id=64ac1364&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ac1364"]])

export default __exports__